import React, { useState, useEffect } from "react";
import Business from "../../images/Business_handshake_2.jpg";
import Tech from "../../images/tech_1.jpg";
import NGO from "../../images/NGO_1.jpg";
import UX from "../../images/UX_1.jpg";
import ComingSoonDivider from '../PowerPack_Common/ComingSoonDivider';

const { board } = window.miro;

export default function JargonTools({
  boardSelection,
  userIsPro,
  environment,
}) {
  const [techJargonCombo, setTechJargonCombo] = useState("");
  const [bizJargonCombo, setBizJargonCombo] = useState("");
  const [uxJargonCombo, setUxJargonCombo] = useState("");
  const [nonProfitJargonCombo, setNonProfitJargonCombo] = useState("");
  const [creating, setCreating] = useState(false);
  const [createTitle, setCreateTitle] = useState("");
  const [newJargonCreation, setNewJargonCreation] = useState({
    title: "",
    first: [],
    second: [],
    third: [],
  });
  const [jargonCreationSaved, setjargonCreationSaved] = useState(0);
  const [savedJargon, setSavedJargon] = useState({
    saved_jargon: {},
  });

  useEffect(async () => {
    let { jargon } = await board.getAppData();

    // WE NEED TO FILTER OUT INVALID APP DATA
    // let cleanJargon = fitlerAppDataForCleanSavedJargon(jargon);
    // setSavedJargon(cleanJargon.saved_jargon);
    if (jargon) {
      setSavedJargon(jargon.saved_jargon);
    }
  }, []);

  /// FILTER INVALID APP DATA
  function fitlerAppDataForCleanSavedJargon(appData_jargon) {
    let cleanedObject = { saved_jargon: {} };
    if (appData_jargon) {
      if (appData_jargon.hasOwn("saved_jargon")) {
        Object.values(appData_jargon.saved_jargon).forEach();
      }
    }
  }

  async function createTechJargonCombo() {
    let chosenVerb = "";
    let chosenAdjective = "";
    let chosenNoun = "";

    let index = 0;

    index = Math.floor(Math.random() * tech_list.verbs.length);
    chosenVerb = tech_list.verbs[index];

    index = Math.floor(Math.random() * tech_list.adjectives.length);
    chosenAdjective = tech_list.adjectives[index];

    index = Math.floor(Math.random() * tech_list.nouns.length);
    chosenNoun = tech_list.nouns[index];

    let combo = `${chosenVerb} ${chosenAdjective} ${chosenNoun}`;
    setTechJargonCombo(combo);

    let viewport = await board.viewport.get();
    let viewportCenterX = viewport.x + 0.5 * viewport.width;
    let viewportCenterY = viewport.y + 0.5 * viewport.height;

    let stickyWidth = viewport.width * 0.2;

    const stickyNoteVerb = await board.createStickyNote({
      content: `<p>${chosenVerb}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.35 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });
    const stickyNoteAdjective = await board.createStickyNote({
      content: `<p>${chosenAdjective}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.55 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteNoun = await board.createStickyNote({
      content: `<p>${chosenNoun}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.75 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    // ---
  }

  async function createBizJargonCombo() {
    let chosenAdverb = "";
    let chosenVerb = "";
    let chosenAdjective = "";
    let chosenNoun = "";

    let index = 0;

    index = Math.floor(Math.random() * business_list.adverbs.length);
    chosenAdverb = business_list.adverbs[index];

    index = Math.floor(Math.random() * business_list.verbs.length);
    chosenVerb = business_list.verbs[index];

    index = Math.floor(Math.random() * business_list.adjectives.length);
    chosenAdjective = business_list.adjectives[index];

    index = Math.floor(Math.random() * business_list.nouns.length);
    chosenNoun = business_list.nouns[index];

    let combo = `${chosenAdverb} ${chosenVerb} ${chosenAdjective} ${chosenNoun}`;

    setBizJargonCombo(combo);

    let viewport = await board.viewport.get();
    let viewportCenterX = viewport.x + 0.5 * viewport.width;
    let viewportCenterY = viewport.y + 0.5 * viewport.height;

    let stickyWidth = viewport.width * 0.2;

    const stickyNoteAdverb = await board.createStickyNote({
      content: `<p>${chosenAdverb}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.3 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteVerb = await board.createStickyNote({
      content: `<p>${chosenVerb}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.5 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteAdjective = await board.createStickyNote({
      content: `<p>${chosenAdjective}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.7 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteNoun = await board.createStickyNote({
      content: `<p>${chosenNoun}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.9 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    // ---
  }

  async function createUxJargonCombo() {
    let chosenAdverb = "";
    let chosenVerb = "";
    let chosenAdjective = "";
    let chosenNoun = "";

    let index = 0;

    index = Math.floor(Math.random() * ux_list.verbs.length);
    chosenVerb = ux_list.verbs[index];

    index = Math.floor(Math.random() * ux_list.adjectives.length);
    chosenAdjective = ux_list.adjectives[index];

    index = Math.floor(Math.random() * ux_list.nouns.length);
    chosenNoun = ux_list.nouns[index];

    let combo = `${chosenVerb} ${chosenAdjective} ${chosenNoun}`;
    setUxJargonCombo(combo);

    let viewport = await board.viewport.get();
    let viewportCenterX = viewport.x + 0.5 * viewport.width;
    let viewportCenterY = viewport.y + 0.5 * viewport.height;

    let stickyWidth = viewport.width * 0.2;

    const stickyNoteVerb = await board.createStickyNote({
      content: `<p>${chosenVerb}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.35 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteAdjective = await board.createStickyNote({
      content: `<p>${chosenAdjective}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.55 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteNoun = await board.createStickyNote({
      content: `<p>${chosenNoun}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.75 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });
    // ---
  }

  async function createNonProfitJargonCombo() {
    let chosenAdverb = "";
    let chosenVerb = "";
    let chosenAdjective = "";
    let chosenNoun = "";

    let index = 0;

    index = Math.floor(Math.random() * non_profit_list.verbs.length);
    chosenVerb = non_profit_list.verbs[index];

    index = Math.floor(Math.random() * non_profit_list.adjectives.length);
    chosenAdjective = non_profit_list.adjectives[index];

    index = Math.floor(Math.random() * non_profit_list.nouns.length);
    chosenNoun = non_profit_list.nouns[index];

    let combo = `${chosenVerb} ${chosenAdjective} ${chosenNoun}`;
    setNonProfitJargonCombo(combo);

    let viewport = await board.viewport.get();
    let viewportCenterX = viewport.x + 0.5 * viewport.width;
    let viewportCenterY = viewport.y + 0.5 * viewport.height;

    let stickyWidth = viewport.width * 0.2;

    let example = 6;

    const stickyNoteVerb = await board.createStickyNote({
      content: `<p>${chosenVerb}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.35 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteAdjective = await board.createStickyNote({
      content: `<p>${chosenAdjective}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.55 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteNoun = await board.createStickyNote({
      content: `<p>${chosenNoun}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.75 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });
    // ---
  }

  async function createMyOwn() {
    setCreating(!creating);
  }

  function updateTitle(e) {
    setCreateTitle(e.target.value);

    let creationToUpdate = { ...newJargonCreation };
    creationToUpdate.title = e.target.value;
    setNewJargonCreation(creationToUpdate);
  }

  // strip HTML
  function htmlStrip(htmlStringList) {
    let cleanArray = [];

    htmlStringList.forEach((htmlString) => {
      let dom = new DOMParser().parseFromString(htmlString, "text/html");
      let txt = dom.body.textContent;
      cleanArray.push(txt);
    });

    return cleanArray;
  }

  async function getListFromBoard(flag) {
    let selection = await board.getSelection();
    let filteredForStickiesTextList = selection
      .filter((item) => item.type === "sticky_note")
      .map((item) => item.content);

    let cleanList = htmlStrip(filteredForStickiesTextList);

    let creationToUpdate = { ...newJargonCreation };
    switch (flag) {
      case "first":
        creationToUpdate.first = cleanList;
        setNewJargonCreation(creationToUpdate);
        break;
      case "second":
        creationToUpdate.second = cleanList;
        setNewJargonCreation(creationToUpdate);
        break;
      case "third":
        creationToUpdate.third = cleanList;
        setNewJargonCreation(creationToUpdate);
        break;
      default:
      // code block
    }
  }

  async function saveNewJargon() {
    let appData = await board.getAppData();
    if (Object.hasOwn("jargon")) {
      let { jargon } = appData;
      jargon.saved_jargon[newJargonCreation.title] = newJargonCreation;
      let newAppData = await board.setAppData("jargon", jargon);
    } else {
      let newSavedJargonObject = {
        saved_jargon: { [newJargonCreation.title]: newJargonCreation },
      };
      let newAppData = await board.setAppData("jargon", newSavedJargonObject);
    }
  }

  async function runSavedJargon(savedJargonObject) {
    let { first, second, third } = savedJargonObject;

    let chosenFirst = "";
    let chosenSecond = "";
    let chosenThird = "";

    let index = 0;

    index = Math.floor(Math.random() * savedJargonObject.first.length);
    chosenFirst = savedJargonObject.first[index];

    index = Math.floor(Math.random() * savedJargonObject.second.length);
    chosenSecond = savedJargonObject.second[index];

    index = Math.floor(Math.random() * savedJargonObject.third.length);
    chosenThird = savedJargonObject.third[index];

    let combo = `${chosenFirst} ${chosenSecond} ${chosenThird}`;
    setTechJargonCombo(combo);

    let viewport = await board.viewport.get();
    let viewportCenterX = viewport.x + 0.5 * viewport.width;
    let viewportCenterY = viewport.y + 0.5 * viewport.height;

    let stickyWidth = viewport.width * 0.2;

    const stickyNoteFirst = await board.createStickyNote({
      content: `<p>${chosenFirst}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.35 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });
    const stickyNoteSecond = await board.createStickyNote({
      content: `<p>${chosenSecond}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.55 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    const stickyNoteThird = await board.createStickyNote({
      content: `<p>${chosenThird}</p>`,
      style: {
        fillColor: "black",
        textAlign: "center",
        textAlignVertical: "middle",
      },
      x: viewport.x + 0.75 * viewport.width,
      y: viewport.y + viewport.height * 0.5,
      width: stickyWidth * 0.9,
    });

    // ---
  }

  return (
    <div className="mt-8 scrollable">
      <div
        id="pre-set-jargon-set-section"
        className="grid tool-container pt-12 pb-4">
        <div className="cs1 ce6">
          <div className="image-container">
            <img
              onClick={createTechJargonCombo}
              className="image-button"
              src={Tech}></img>
            <span className="centered image-overlay-text">Tech</span>
          </div>
        </div>
        {/* <div className="cs1 ce12 jargon-combo">
        <div>{techJargonCombo}</div>
      </div> */}

        <div className="cs7 ce12">
          <div className="image-container">
            <img
              onClick={createBizJargonCombo}
              className="image-button"
              src={Business}></img>
            <div className="centered image-overlay-text">Biz</div>
          </div>
        </div>
        {/* <div className="cs1 ce12 jargon-combo">
        <div>{bizJargonCombo}</div>
      </div> */}

        <div className="cs1 ce6">
          <div className="image-container">
            <img
              onClick={createUxJargonCombo}
              className="image-button"
              src={UX}></img>
            <div className="centered image-overlay-text">UX</div>
          </div>
        </div>
        {/* <div className="cs1 ce12 jargon-combo">
        <div>{uxJargonCombo}</div>
      </div> */}

        <div className="cs7 ce12">
          <div className="image-container">
            <img
              onClick={createNonProfitJargonCombo}
              className="image-button"
              src={NGO}></img>
            <div className="centered image-overlay-text">NGO</div>
          </div>
        </div>
      </div>

      {/* More tools on the way */}
      <ComingSoonDivider visible={true} />
      <div
        id="create-my-own-jargon-section"
        className="grid mb-16 tool-container pos-rel">
        <div className="centered-overlay crosshatch">
          <span
            onClick={() =>
              window.open("https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs", "_blank")
            }
            className="p-small pro-upgrade">
            PRO PLAN
          </span>
        </div>

        <div id="create-my-own-title-section" className="grid cs1 ce12">
          <div className="h3 cs1 ce12">
            <b>Create Your own Jargon</b>
          </div>
          <div className="cs1 ce12 p-medium">
            Save funny jargon from your team or industry.
          </div>
        </div>
        {/* <div
          id="create-my-own-selected"
          className="grid cs1 ce12"
          style={{
            display: "block",
          }}>
          <div id="create-title" className="form-group-small mb-16 cs1 ce12">
            <label>Name this set:</label>
            <input
              className="input input-small"
              type="text"
              placeholder="Name the Jargon set"
              value={createTitle}
              onChange={(e) => {
                updateTitle(e);
              }}
            />
          </div>
          <div className="grid">
            <div className="p p-medium cs1 ce12">
              Pick three groups of sticky notes that will be randomly selected
              from in order. <br></br>One suggestion: 1) verbs, 2) adjectives,
              3) nouns{" "}
            </div>
            <div className="grid cs1 ce4">
              <button
                type="button"
                onClick={() => getListFromBoard("first")}
                className="cs1 ce12 button button-secondary fix-button-secondary button-small">
                <b>1</b>st Set
              </button>
            </div>
            <div className="grid cs5 ce8">
              <button
                type="button"
                onClick={() => getListFromBoard("second")}
                className=" cs1 ce12 button button-secondary fix-button-secondary button-small">
                <b>2</b>nd Set
              </button>
            </div>
            <div className="grid cs9 ce12">
              <button
                type="button"
                onClick={() => getListFromBoard("third")}
                className="cs1 ce12 button button-secondary fix-button-secondary button-small">
                <b>3</b>rd Set
              </button>
            </div>
            <div id="verb-row" className="grid cs1 ce4 align-top">
              {newJargonCreation.first.map((word) => (
                <div key={word} className="cs1 ce12 p p-medium">
                  {word}
                </div>
              ))}
            </div>
            <div id="adjective-row" className="grid cs5 ce8 align-top">
              {newJargonCreation.second.map((word) => (
                <div key={word} className="cs1 ce12 p p-medium">
                  {word}
                </div>
              ))}
            </div>
            <div id="noun-row" className="grid cs9 ce12 align-top">
              {newJargonCreation.third.map((word) => (
                <div key={word} className="cs1 ce12 p p-medium">
                  {word}
                </div>
              ))}
            </div>

            <button
              type="button"
              className="button button-primary button-small cs1 ce6 mt-16">
              Run this Jargon
            </button>
            <button
              type="button"
              className="button button-secondary fix-button-secondary button-small cs7 ce12 "
              onClick={saveNewJargon}>
              Save
            </button>
          </div>
        </div> */}
      </div>
      {/* 
      <div
        id="saved-jargon-section"
        className="grid mb-16 tool-container pos-rel">
        <div className="centered-overlay crosshatch"></div>
        <div id="saved-jargon-title-section" className="grid cs1 ce12">
          <div className="h3 cs1 ce12 ">
            <b>My Created Jargon</b>
          </div>
        </div>
        <>
          {Object.values(savedJargon).map((savedJargonObject, index) => (
            <div
              key={index}
              onClick={(savedJargonObject) => {
                runSavedJargon(savedJargonObject);
              }}
              type="button"
              className="cs1 ce12 button button-secondary button-small">
              {savedJargonObject.title}
            </div>
          ))}
        </>
      </div>
 */}
    </div>
  );
}

const business_list = {
  adverbs: [
    "appropriately",
    "assertively",
    "authoritatively",
    "collaboratively",
    "compellingly",
    "competently",
    "completely",
    "consistently",
    "continually",
    "conveniently",
    "credibly",
    "distinctively",
    "dramatically",
    "dynamically",
    "efficiently",
    "energistically",
    "enthusiastically",
    "fungibly",
    "globally",
    "holisticly",
    "interactively",
    "intrinsically",
    "objectively",
    "proactively",
    "professionally",
    "progressively",
    "quickly",
    "rapidiously",
    "seamlessly",
    "sustainably",
    "synergistically",
    "uniquely",
  ],
  verbs: [
    "actualize",
    "administrate",
    "aggregate",
    "architect",
    "benchmark",
    "brand",
    "build",
    "cloudify",
    "communicate",
    "conceptualize",
    "check in on",
    "get aligned around",
    "coordinate",
    "create",
    "cultivate",
    "customize",
    "deliver",
    "deploy",
    "develop",
    "dinintermediate",
    "disseminate",
    "drive",
    "embrace",
    "e-enable",
    "empower",
    "enable",
    "engage",
    "engineer",
    "enhance",
    "envisioneer",
    "evisculate",
    "evolve",
    "expedite",
    "exploit",
    "extend",
    "fabricate",
    "facilitate",
    "fashion",
    "formulate",
    "foster",
    "generate",
    "grow",
    "harness",
    "impact",
    "implement",
    "incentivize",
    "incept",
    "incubate",
    "initiate",
    "innovate",
    "integrate",
    "iterate",
    "leverage existing",
    "leverage other's",
    "level-set",
    "maintain",
    "matrix",
    "maximize",
    "mesh",
    "monetize",
    "morph",
    "myocardinate",
    "negotiate",
    "network",
    "optimize",
    "onboard",
    "orchestrate",
    "parallel task",
    "plagiarize",
    "pontificate",
    "predominate",
    "procrastinate",
    "productivate",
    "productize",
    "promote",
    "provide access to",
    "put a pin and come back later to",
    "table, for now, the idea of",
    "double click on",
    "drill down on",
    "stay at the high level on",
    "really get into the weeds of",
    "build a portfolio of",
    "prioritize",
    "reprioritize",
    "pursue",
    "recaptiualize",
    "reconceptualize",
    "redefine",
    "re-engineer",
    "reintermediate",
    "reinvent",
    "repurpose",
    "restore",
    "revolutionize",
    "right-shore",
    "scale",
    "seize",
    "simplify",
    "strategize",
    "streamline",
    "supply",
    "syndicate",
    "synergize",
    "synthesize",
    "target",
    "touch base",
    "transform",
    "transition",
    "underwhelm",
    "unleash",
    "utilize",
    "visualize",
    "whiteboard",
  ],
  adjectives: [
    "24/7",
    "24/365",
    "accurate",
    "adaptive",
    "agile",
    "alternative",
    "an expanded array of",
    "B2B",
    "B2C",
    "backend",
    "backward-compatible",
    "best-of-breed",
    "bleeding-edge",
    "bricks-and-clicks",
    "business",
    "clicks-and-mortar",
    "client-based",
    "client-centered",
    "client-centric",
    "client-focused",
    "cloud-based",
    "cloud-centric",
    "cloudified",
    "collaborative",
    "compelling",
    "competitive",
    "cooperative",
    "corporate",
    "cost effective",
    "covalent",
    "cross functional",
    "cross-media",
    "cross-platform",
    "cross-unit",
    "customer directed",
    "customized",
    "cutting-edge",
    "distinctive",
    "distributed",
    "diverse",
    "dynamic",
    "e-business",
    "economically sound",
    "effective",
    "efficient",
    "elastic",
    "emerging",
    "empowered",
    "enabled",
    "end-to-end",
    "enterprise",
    "enterprise-wide",
    "equity invested",
    "error-free",
    "ethical",
    "excellent",
    "exceptional",
    "extensible",
    "enduring",
    "extensive",
    "flexible",
    "focused",
    "frictionless",
    "front-end",
    "fully researched",
    "fully tested",
    "functional",
    "functionalized",
    "fungible",
    "future-proof",
    "global",
    "go forward",
    "goal-oriented",
    "granular",
    "high standards in",
    "high-payoff",
    "hyperscale",
    "high-quality",
    "highly efficient",
    "holistic",
    "impactful",
    "inexpensive",
    "innovative",
    "installed base",
    "integrated",
    "interactive",
    "interdependent",
    "intermandated",
    "interoperable",
    "intuitive",
    "just in time",
    "leading-edge",
    "leveraged",
    "long-term high-impact",
    "low-risk high-yield",
    "magnetic",
    "maintainable",
    "market positioning",
    "market-driven",
    "mission-critical",
    "multidisciplinary",
    "multifunctional",
    "multimedia based",
    "next-generation",
    "on-demand",
    "one-to-one",
    "open-source",
    "optimal",
    "orthogonal",
    "out-of-the-box",
    "pandemic",
    "parallel",
    "performance based",
    "plug-and-play",
    "premier",
    "premium",
    "principle-centered",
    "proactive",
    "process-centric",
    "professional",
    "progressive",
    "prospective",
    "quality",
    "real-time",
    "reliable",
    "resource-sucking",
    "resource-maximizing",
    "resource-leveling",
    "revolutionary",
    "robust",
    "scalable",
    "seamless",
    "stand-alone",
    "standardized",
    "standards compliant",
    "state of the art",
    "sticky",
    "strategic",
    "superior",
    "sustainable",
    "synergistic",
    "tactical",
    "team building",
    "team driven",
    "technically sound",
    "timely",
    "top-line",
    "transparent",
    "turnkey",
    "ubiquitous",
    "unique",
    "user-centric",
    "user friendly",
    "value-added",
    "vertical",
    "viral",
    "virtual",
    "visionary",
    "web-enabled",
    "wireless",
    "world-class",
    "worldwide",
  ],
  nouns: [
    "action items",
    "adoption",
    "alignments",
    "applications",
    "architectures",
    "bandwidth",
    "benefits",
    "best practices",
    "catalysts for change",
    "channels",
    "clouds",
    "collaboration and idea-sharing",
    "communities",
    "content",
    "convergence",
    "core competencies",
    "customer service",
    "data",
    "deliverables",
    "e-business",
    "e-commerce",
    "e-markets",
    "e-tailers",
    "e-services",
    "experiences",
    "expertise",
    "functionalities",
    "fungibility",
    "growth strategies",
    "human capital",
    "ideas",
    "imperatives",
    "infomediaries",
    "information",
    "infrastructures",
    "initiatives",
    "innovation",
    "intellectual capital",
    "interfaces",
    "internal or organic sources",
    "leadership",
    "leadership skills",
    "manufactured products",
    "markets",
    "materials",
    "meta-services",
    "methodologies",
    "methods of empowerment",
    "metrics",
    "mindshare",
    "models",
    "networks",
    "niches",
    "niche markets",
    "nosql",
    "opportunities",
    "outside the box thinking",
    "outsourcing",
    "paradigms",
    "partnerships",
    "platforms",
    "portals",
    "potentialities",
    "process improvements",
    "processes",
    "products",
    "quality vectors",
    "relationships",
    "resources",
    "results",
    "ROI",
    "scenarios",
    "schemas",
    "scrums",
    "services",
    "solutions",
    "sources",
    "sprints",
    "strategic theme areas",
    "storage",
    "supply chains",
    "synergy",
    "systems",
    "technologies",
    "technology",
    "testing procedures",
    "total linkage",
    "users",
    "value",
    "vortals",
    "web-readiness",
    "web services",
    "wins",
    "virtualization",
  ],
};

const tech_list = {
  verbs: [
    "aggregate",
    "architect ",
    "benchmark",
    "brand",
    "cultivate",
    "deliver",
    "deploy",
    "disintermediate",
    "drive",
    "e-enable",
    "embrace",
    "empower",
    "enable",
    "engage",
    "engineer",
    "enhance",
    "evolve",
    "expedite",
    "exploit",
    "extend",
    "facilitate",
    "generate",
    "grow",
    "harness",
    "implement",
    "incentivize",
    "incubate",
    "innovate",
    "integrate",
    "iterate",
    "leverage",
    "matrix",
    "maximize",
    "mesh",
    "monetize",
    "morph",
    "optimize",
    "orchestrate",
    "productize",
    "recontextualize",
    "redefine",
    "reintermediate",
    "reinvent",
    "repurpose",
    "revolutionize",
    "scale",
    "seize",
    "strategize",
    "streamline",
    "syndicate",
    "synergize",
    "synthesize",
    "target",
    "transform",
    "transition",
    "unleash",
    "utilize",
    "visualize",
    "whiteboard",
    "aggregate",
    "architect ",
    "benchmark",
    "brand",
    "cultivate",
    "deliver",
    "deploy",
    "disintermediate",
    "drive",
    "embrace",
    "empower",
    "enable",
    "engage",
    "engineer",
    "enhance",
    "envisioneer",
    "evolve",
    "expedite",
    "exploit",
    "extend",
    "facilitate",
    "generate",
    "grow",
    "harness",
    "implement",
    "incentivize",
    "incubate",
    "innovate",
    "integrate",
    "iterate",
    "leverage",
    "matrix",
    "maximize",
    "mesh",
    "monetize",
    "morph",
    "optimize",
    "orchestrate",
    "productize",
    "recontextualize",
    "redefine",
    "reintermediate",
    "reinvent",
    "repurpose",
    "revolutionize",
    "scale",
    "seize",
    "strategize",
    "streamline",
    "syndicate",
    "synergize",
    "synthesize",
    "target",
    "transform",
    "transition",
    "unleash",
    "utilize",
    "visualize",
    "whiteboard",
  ],
  adjectives: [
    "24/365",
    "24/7",
    "5G",
    "AI-enabled",
    "autonomous",
    "B2B",
    "B2C",
    "back-end",
    "best-of-breed",
    "bleeding-edge",
    "bricks-and-clicks",
    "clicks-and-mortar",
    "cloud",
    "hybrid cloud",
    "collaborative",
    "compelling",
    "cross-platform",
    "cross-media",
    "customized",
    "cutting-edge",
    "distributed",
    "dot-com",
    "dynamic",
    "e-business",
    "efficient",
    "end-to-end",
    "enterprise",
    "extensible",
    "frictionless",
    "front-end",
    "global",
    "granular",
    "holistic",
    "impactful",
    "innovative",
    "integrated",
    "interactive",
    "intuitive",
    "killer",
    "leading-edge",
    "magnetic",
    "mission-critical",
    "next-generation",
    "one-to-one",
    "open-source",
    "out-of-the-box",
    "plug-and-play",
    "proactive",
    "real-time",
    "revolutionary",
    "rich",
    "robust",
    "scalable",
    "seamless",
    "sexy",
    "sticky",
    "strategic",
    "synergistic",
    "transparent",
    "turn-key",
    "ubiquitous",
    "user-centric",
    "value-added",
    "vertical",
    "viral",
    "virtual",
    "visionary",
    "web-enabled",
    "web-3",
    "wireless",
    "world-class",
  ],
  nouns: [
    "AI",
    "action-items",
    "applications",
    "architectures",
    "bandwidth",
    "channels",
    "communities",
    "content",
    "convergence",
    "deliverables",
    "drones",
    "e-business",
    "e-commerce",
    "e-markets",
    "e-services",
    "e-tailers",
    "experiences",
    "eyeballs",
    "functionalities",
    "infomediaries",
    "infrastructures",
    "initiatives",
    "interfaces",
    "machine learning",
    "markets",
    "methodologies",
    "metrics",
    "mindshare",
    "models",
    "networks",
    "niches",
    "paradigms",
    "partnerships",
    "platforms",
    "portals",
    "relationships",
    "ROI",
    "synergies",
    "web-readiness",
    "schemas",
    "solutions",
    "supply-chains",
    "systems",
    "technologies",
    "users",
    "vortals",
    "web services",
  ],
};

const ux_list = {
  verbs: [
    "deliver",
    "bifurcate",
    "decouple",
    "segment",
    "spatialize",
    "design",
    "research",
    "execute",
    "initialize",
    "empathize with",
    "instantiate",
    "build momementum around",
    "segment",
    "drill down on",
    "double click on",
    "table",
    "put a pin in",
    "push forward",
    "recontextualize",
    "reenvision",
    "compartmentalize",
    "expand",
    "diversify",
    "laterally progress",
    "build intention around",
    "create space for",
    "socialize",
    "rearticulate",
    "articulate",
    "build meaning around",
    "redefine",
    "reassociate",
    "envelop",
    "assist",
    "distinguish",
    "accelerate",
    "highlight",
    "investigate",
    "follow our intuition on",
    "build a case for",
    "drive data making around",
    "explore",
    "unpack",
    "reassess",
    "encapsulate",
    "reprioritize",
    "prioritize",
    "partition",
    "differentiate",
    "concentrate on",
    "contextualize",
    "emphasize",
    "zoom in on",
    "hone in on",
    "position",
    "reposition",
    "mockup",
    "A-B test",
  ],
  adjectives: [
    "A-B tested",
    "unbiased",
    "impartial",
    "studied",
    "ground-truthed",
    "investigated",
    "validated",
    "verified",
    "intuited",
    "biased",
    "segmented",
    "user-segmented",
    "differentiated",
    "unique",
    "invalidated",
    "under-appreciated",
    "insufficiently-studied",
    "percievable",
    "perceptible",
    "unquantifiable",
    "quantifiable",
    "misunderstood",
    "dynamic",
    "responsive",
    "reactive",
    "user-specific",
    "use-case-specific",
    "user-agnostic",
    "use-case-agnostic",
    "reimagined",
    "rearticulated",
    "repositioned",
    "market-aligned",
    "use-case-aligned",
    "aligned",
    "alternative",
    "optimized",
    "funneled",
    "faceted",
    "A/B tested",
    "grouped",
    "unified",
  ],
  nouns: [
    "deliverables",
    "A-B tests",
    "methods",
    "processes",
    "experiences",
    "services",
    "figma sketch",
    "sketches",
    "thumbnails",
    "timelines",
    "service blueprints",
    "customer journey maps",
    "customer journeys",
    "personas",
    "demographics",
    "segments",
    "subsegments",
    "ecosystem maps",
    "competitive audits",
    "value propositions",
    "stakeholder interviews",
    "key performance indicators",
    "decision trees",
    "brainstorms",
    "moodboards",
    "storyboards",
    "user flows",
    "task analysis",
    "user interviews",
    "taxonomies",
    "content audits",
    "heuristic analysis",
    "sitemaps",
    "product roadmaps",
    "feature roadmaps",
    "use cases",
    "user stories",
    "scenarios",
    "metric analysis",
    "focus groups",
    "quantitative surveying",
    "usability testing",
    "card sorting",
    "A/B tests",
    "eye tracking",
    "accessibility analysis",
    "wirreframes",
    "prototypes",
    "pattern libraries",
    "design systems",
    "diary studies",
    "mental models",
    "visual lexicons",
    "design sprints",
    "biases",
    "users",
    "user segments",
    "funnels",
    "niches",
    "facets",
    "flows",
    "categories",
    "hierarchies",
    "paper prototypes",
  ],
};

const non_profit_list = {
  verbs: [
    "cold call",
    "leverage",
    "reframe",
    "dive deep",
    "frame",
    "message",
    "resist",
    "ideate",
    "mobilize",
    "enable",
    "institutionalize",
    "organize",
    "enable",
    "empower",
    "activate",
    "co-create",
    "co-design",
    "build consensus around",
    "build momentum for",
    "shift the narrative in favor of",
    "pull together",
    "community organize",
    "rebrand",
    "institute",
    "emphasize",
    "re-emphasize",
    "de-emphasize",
    "rearticulate",
    "fundraise for",
    "cheerlead for",
    "crowdfund",
    "instigate",
    "accelerate",
    "ignite",
    "embolden",
    "decriminalize",
    "affirm",
    "firmly implant",
    "build a case for",
  ],
  adjectives: [
    "people-centric",
    "emerging",
    "emergent",
    "bottom up",
    "triggered",
    "catalytic",
    "exploitable",
    "empowered",
    "shifting",
    "community-driven",
    "attainable",
    "context-appropriate",
    "unbiased",
    "ambitious",
    "long term",
    "immediate",
    "rapid",
    "alternative",
    "circular",
    "consultant-driven",
    "outsider",
    "socially equitable",
    "resilient",
    "forward-looking",
    "systematic",
    "dynamic",
    "collective",
    "communal",
    "communitiy",
    "shared",
    "top-down",
    "bottom-up",
    "top-down-driven",
    "bottom-up-driven",
    "solutions-oriented",
    "triple bottom line",
    "social-sector",
    "data-driven",
    "outcome-oriented",
    "evidence-based",
    "community-based",
    "community-lead",
    "organic",
    "sustainable",
    "mission-driven",
    "multi-stakeholder",
    "public-private",
    "regenerative",
  ],
  nouns: [
    "synergy",
    "public-private-partnerships",
    "programs",
    "sustainability",
    "resistance",
    "outcomes",
    "strategic partnerships",
    "bandwidth",
    "deep dives",
    "equity",
    "social equity",
    "epathy",
    "contextulization",
    "community engagement",
    "stakeholders",
    "processes",
    "buy-in",
    "tactics",
    "strategies",
    "stragic insights",
    "campaign plans",
    "campaigns",
    "media moments",
    "on the ground momentum",
    "ears to the ground",
    "shifted narratives",
    "storytelling",
    "spaces",
    "catalytic moments",
    "leverage points",
    "wisdom",
    "empowerment",
    "conciousness",
    "paradigm shifts",
    "SMART goals",
    "Gantt charts",
    "mental models",
    "logic models",
    "power mapping",
    "grant proposals",
    "grant writing",
    "scopes of work",
    "terms of reference",
    "mission statements",
    "vision statements",
    "core values",
    "medium term plans",
    "responses",
    "action-alerts",
    "email blasts",
    "petitioning",
    "social media strategies",
    "digital strategies",
    "donation drives",
    "membership",
    "annual reports",
    "workshops",
    "community charrettes",
    "charitable works",
    "core competencies",
    "ladders of engagement",
    "resiliency",
    "lived experiences",
    "community leaders",
    "consensus building",
    "learnings",
    "thought leadership",
    "low hanging fruit",
    "impact",
    "change",
    "impact investments",
  ],
};
